module.exports = "<tb-dashtransfer-react></tb-dashtransfer-react>";